import { ADMIN_PASSW } from '@query/shared';
import { useState, type FormEvent } from 'react';

export interface InputAnyProps {
  placeholder: string;
  onSubmit: (value: string) => void;
}

/**
 * Поле ввода — перенос InputFC (FC.kt:16-39).
 * Тип поля зависит от подсказки: пароль администратора вводится скрытно.
 */
export function InputAny({ placeholder, onSubmit }: InputAnyProps) {
  const [text, setText] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = text;
    setText('');
    onSubmit(value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        id="inputAny"
        type={placeholder === ADMIN_PASSW ? 'password' : 'text'}
        className="cl3"
        placeholder={placeholder}
        value={text}
        size={Math.max(text.length, 1)}
        onChange={(event) => setText(event.target.value)}
      />
    </form>
  );
}
